import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Auth } from '@aws-amplify/auth';

import { environment } from 'src/environments/environment';

import { from, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

/**
 * This will append jwt token for the http requests.
 *
 * @export
 * @class AuthInterceptor
 * @implements {HttpInterceptor}
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  blacklist = [
    environment.url.bffInternBETranslations,
    'https://api.mapbox.com',
    'https://events.mapbox.com',
    '/mapbox/styles/v1/',
    'https://data.einsatzwetter.de',
    'https://mapserver.metops.net',
  ];

  // auth.interceptor.service.ts
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.urlDoesNotNeedAuth(request.url)) {
      return next.handle(request);
    }

    return from(Auth.currentSession()).pipe(
      switchMap(session => {
        const jwt = session.getIdToken().getJwtToken();
        const authReq = request.clone({
          setHeaders: { Authorization: `Bearer ${jwt}` },
        });
        return next.handle(authReq);
      }),
      catchError(err => {
        // WICHTIG: Wenn Auth.currentSession() fehlschlägt,
        // schicken wir den Request ohne Token weiter.
        // Falls 'err' aber bereits ein HttpErrorResponse vom Server ist,
        // werfen wir ihn einfach nur weiter, damit er nicht doppelt geloggt wird.
        if (err instanceof HttpErrorResponse) {
          return throwError(() => err);
        }
        return next.handle(request);
      })
    );
  }

  private urlDoesNotNeedAuth(url: string): boolean {
    return this.blacklist.some(blacklistUrl => url.includes(blacklistUrl));
  }
}
